import { motion } from "framer-motion";

const variants = {
  primary:   "bg-amber-500 hover:bg-amber-400 text-amber-950 font-bold shadow-lg shadow-amber-900/40 border border-amber-400",
  secondary: "bg-amber-900/60 hover:bg-amber-800/60 text-amber-200 border border-amber-700/40",
  danger:    "bg-red-900/80 hover:bg-red-800 text-red-200 border border-red-700/60",
  night:     "bg-indigo-900/70 hover:bg-indigo-800/70 text-indigo-200 border border-indigo-700/40",
  ghost:     "bg-transparent hover:bg-amber-950/40 text-amber-400 border border-amber-800/30",
  success:   "bg-emerald-800/80 hover:bg-emerald-700 text-emerald-100 border border-emerald-600/60",
  wolf:      "bg-red-950/80 hover:bg-red-900 text-red-200 border border-red-800/60",
};

export function Btn({ children, onClick, variant = "primary", className = "", disabled = false, size = "md" }) {
  const base = `font-semibold rounded-2xl transition-all active:scale-95 select-none
    ${disabled ? "opacity-40 cursor-not-allowed" : "cursor-pointer"}
    ${size === "sm" ? "px-3 py-1.5 text-xs" : size === "lg" ? "px-6 py-4 text-base" : "px-4 py-2.5 text-sm"}`;
  return (
    <motion.button
      whileTap={disabled ? {} : { scale: 0.95 }}
      onClick={disabled ? undefined : onClick}
      className={`${base} ${variants[variant] || variants.primary} ${className}`}>
      {children}
    </motion.button>
  );
}
